import { useTranslation } from 'react-i18next'

import { InfoIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import { getEarningsHeadline } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/helpers'

import { earningsBridgeCopies } from '../constants'
import BridgeColumn from './BridgeColumn/BridgeColumn'
import { getEarningsBridgeColumnItems, getEarningsBridgeHeadlineValues } from './helpers'
import * as Styles from './styles'

const NetSalesToMarginContent = ({ earnings }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const copies = earningsBridgeCopies[getEarningsHeadline(earnings).level]
  const columns = getEarningsBridgeColumnItems(earnings, i18n.language)

  return (
    <>
      <CardDescription>{t(copies.subtitle)}</CardDescription>
      <Styles.Body>
        <Styles.Headline>
          <InfoIcon size={20} color={theme.colors.text.default} />
          <Text type="titleM">{t(copies.headline, getEarningsBridgeHeadlineValues(earnings, i18n.language))}</Text>
        </Styles.Headline>
        <Styles.Columns>
          {columns.map(column => (
            <BridgeColumn
              key={column.key}
              label={t(column.label)}
              amount={column.amount}
              offset={column.offset}
              height={column.height}
              isPlaceholder={column.isPlaceholder}
              isDeduction={column.isDeduction}
              isNegative={column.isNegative}
            />
          ))}
        </Styles.Columns>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t(copies.note)}
        </Text>
      </Styles.Body>
    </>
  )
}

export default NetSalesToMarginContent
